import React from 'react'
import { useWillPipe } from '@morningtrain/react-pipelines'
import { useModel } from '@morningtrain/react-resources'
import { mapToObject } from '@morningtrain/react-helpers'

export default function SetModelOnPayloadOnPipe () {
  const model = useModel()

  useWillPipe((payload) => {
    payload.model = mapToObject(model)

    return payload
  }, [model])

  return null
}
